/**
 * Created by Aleksandr on 08.05.2024
 */

const CustomRewardView = cc.Node.extend({
    ctor: function (reward, index) {
        this._super();

        this.reward = reward;
        this.index = index;
        this.hasAnimation = RewardTypes[reward.type].getCustomRewardIcon() instanceof VirtualJson;

        this.createIcon();
        this.createTooltip();
        this.createAnimation();
        this.createProgress();

        this.setVisible(false);

        this.onResize();
    },

    setUpIconSpine: function () {
        const rewardType = RewardTypes[this.reward.type];
        const icon = new cleverapps.Spine(rewardType.getCustomRewardIcon());
        const animation = rewardType.getCustomRewardIconAnimation ? rewardType.getCustomRewardIconAnimation(this.reward.options).before : "animation";
        icon.setAnimation(0, animation, true);
        return icon;
    },

    setUpIconSprite: function () {
        const rewardType = RewardTypes[this.reward.type];
        return new cc.Sprite(rewardType.getCustomRewardIcon());
    },

    createIcon: function () {
        const styles = cleverapps.styles.CustomRewardView.icon;

        const image = cleverapps.skins.getSlot("sidebarBg") || bundles.sidebar.frames.icon_bg;
        const bg = this.bg = cleverapps.UI.createScale9Sprite(image);
        this.addChild(bg);
        bg.setAlignment(bg.width / 2, bg.height / 2);
        this.setContentSize(bg.getContentSize());

        const icon = this.icon = this.hasAnimation ? this.setUpIconSpine() : this.setUpIconSprite();
        icon.setAlignment(styles.position);
        bg.addChild(icon);
    },

    createTooltip: function () {
        const text = RewardTypes[this.reward.type].getCustomRewardText && RewardTypes[this.reward.type].getCustomRewardText(this.reward.getValue(), true);
        if (!text) {
            return;
        }
        const styles = cleverapps.styles.CustomRewardView.tooltip;

        const tooltip = this.tooltip = new cc.Scale9Sprite(bundles.custom_reward.frames.tooltip_bubble);
        tooltip.setContentSize2(styles);
        tooltip.setAlignment(styles);
        tooltip.setVisible(false);
        this.addChild(tooltip);

        const tooltipArrow = new cc.Sprite(bundles.custom_reward.frames.tooltip_arrow);
        tooltipArrow.setAlignment(styles.arrow);
        tooltip.addChild(tooltipArrow);

        const tooltipText = this.tooltipText = cleverapps.UI.generateOnlyText(text, cleverapps.styles.FONTS.CUSTOM_REWARD_TOOLTIP_TEXT);
        tooltipText.fitTo(tooltip.width - styles.offset);
        tooltipText.setAlignment(tooltip.width / 2, tooltip.height / 2);
        tooltip.addChild(tooltipText);
    },

    createAnimation: function () {
        if (!RewardTypes[this.reward.type].getCustomRewardAnimation) {
            return;
        }
        const styles = cleverapps.styles.CustomRewardView;

        const animation = this.rewardAnimation = new cleverapps.Spine(RewardTypes[this.reward.type].getCustomRewardAnimation());
        animation.setAlignment(styles.animation);
        animation.setVisible(false);
        this.addChild(animation);
    },

    createProgress: function () {
        const rewardType = RewardTypes[this.reward.type];
        if (!rewardType.getCustomRewardProgress || !rewardType.getCustomRewardProgress()) {
            return;
        }
        const styles = cleverapps.styles.CustomRewardView;

        const animation = rewardType.getCustomRewardProgressAnimation ? rewardType.getCustomRewardProgressAnimation(this.reward.options).before : "animation";

        const progress = this.progress = new cleverapps.Spine(rewardType.getCustomRewardProgress());
        progress.setAnimation(0, animation, true);
        progress.setAlignment(styles.progress);
        progress.setScale(Math.min(1, this.width / progress.width));
        this.bg.addChild(progress);
    },

    collectAnimate: function () {
        const styles = cleverapps.styles.CustomRewardView;
        const rewardType = RewardTypes[this.reward.type];
        const animationDelay = this.index * this.getAnimationDuration();

        this.runAction(new cc.Sequence(
            new cc.DelayTime(animationDelay + 0.1),
            new cc.Show(),
            new cc.DelayTime(0.9),
            new cc.CallFunc(() => {
                if (rewardType.getCustomRewardCloseEffect) {
                    cleverapps.effects.fire(rewardType.getCustomRewardCloseEffect());
                }
            }),
            new cc.MoveBy(0.5, styles.hideOffset, 0).easing(cc.easeInOut(1)),
            new cc.RemoveSelf()
        ));

        this.bg.runAction(new cc.Spawn(
            new cc.Sequence(
                new cc.DelayTime(animationDelay),
                new cc.MoveBy(0, styles.hideOffset, 0),
                new cc.DelayTime(0.2),
                new cc.CallFunc(() => {
                    if (rewardType.getCustomRewardOpenEffect) {
                        cleverapps.effects.fire(rewardType.getCustomRewardOpenEffect());
                    }
                }),
                new cc.MoveBy(0.5, -styles.hideOffset, 0).easing(cc.easeBackOut())
            ),
            new cc.Sequence(
                new cc.DelayTime(animationDelay + 0.1),
                new cc.CallFunc(() => {
                    if (this.rewardAnimation) {
                        this.rewardAnimation.setVisible(true);
                        this.rewardAnimation.setAnimation(0, "animation", false);
                        this.rewardAnimation.setCompleteListenerRemove();
                    }
                    if (rewardType.getCustomRewardIconAnimation && this.icon) {
                        const iconAnimation = rewardType.getCustomRewardIconAnimation(this.reward.options);
                        this.icon.setAnimationAndIdleAfter(iconAnimation.during, iconAnimation.after);
                    }
                    if (rewardType.getCustomRewardIconAnimation && this.progress) {
                        const progressAnimation = rewardType.getCustomRewardProgressAnimation(this.reward.options);
                        this.progress.setAnimationAndIdleAfter(progressAnimation.during, progressAnimation.after);
                    }
                })
            )
        ));

        if (this.tooltip) {
            this.tooltip.setScale(0.2);
            this.tooltip.runAction(new cc.Sequence(
                new cc.DelayTime(animationDelay + 0.1),
                new cc.Show(),
                new cc.RotateBy(0, styles.tooltip.showUpRotation),
                new cc.Spawn(
                    new cc.Sequence(
                        new cc.MoveBy(0, styles.tooltip.xOffset, -styles.tooltip.yOffset),
                        new cc.MoveBy(0.3, -styles.tooltip.xOffset, styles.tooltip.yOffset)
                    ),
                    new cc.Sequence(
                        new cc.ScaleTo(0.4, 1.2),
                        new cc.ScaleTo(0.2, 1)
                    ),
                    new cc.Sequence(
                        new cc.RotateBy(0.3, -styles.tooltip.showUpRotation).easing(cc.easeOut(2)),
                        new cc.RotateBy(0.1, -styles.tooltip.afterShowUpRotation),
                        new cc.RotateBy(0.1, styles.tooltip.afterShowUpRotation)
                    )
                )
            ));
        }

        if (this.tooltipText) {
            const scale = this.tooltipText.getScale();
            this.tooltipText.runAction(new cc.Sequence(
                new cc.DelayTime(1),
                new cc.CallFunc(() => {
                    if (rewardType.getCustomRewardEffect) {
                        cleverapps.effects.fire(rewardType.getCustomRewardEffect());
                    }
                }),
                new cc.ScaleTo(0.15, scale * 1.15),
                new cc.CallFunc(() => {
                    this.tooltipText.setString(rewardType.getCustomRewardText(this.reward.getValue()));
                    this.tooltipText.fitTo(this.tooltip.width - styles.tooltip.offset);
                }),
                new cc.CallFunc(() => {
                    if (rewardType.getCustomRewardAfterUpdateEffect) {
                        cleverapps.effects.fire(rewardType.getCustomRewardAfterUpdateEffect());
                    }
                }),
                new cc.ScaleTo(0.15, scale)
            ));
        }
    },

    getAnimationDuration: function () {
        return 1;
    },

    onResize: function () {
        const styles = cleverapps.styles.CustomRewardView;

        this.setScale(cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? 0.8 : 1);

        const sceneSize = cleverapps.resolution.getSceneSize();
        this.setAlignment(sceneSize.width - this.width - styles.padding, styles.y);
    }
});

cleverapps.styles.COLORS.CUSTOM_REWARD_TOOLTIP_COLOR = new cc.Color(148, 49, 19, 255);

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    CUSTOM_REWARD_TOOLTIP_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.CUSTOM_REWARD_TOOLTIP_COLOR
    }
});

cleverapps.styles.CustomRewardView = {
    y: 120,

    hideOffset: 500,
    padding: 10,

    tooltip: {
        arrow: {
            x: { align: "right", dx: 8 },
            y: { align: "bottom", dy: -8 }
        },

        x: { align: "left", dx: -80 },
        y: { align: "top", dy: 45 },

        width: 125,
        height: 75,
        offset: 20,
        showUpRotation: 150,
        afterShowUpRotation: 10,
        xOffset: 200,
        yOffset: 100
    },
    animation: {
        x: { align: "center" },
        y: { align: "center" }
    },
    progress: {
        x: { align: "left", dx: 0 },
        y: { align: "bottom", dy: -40 }
    },
    icon: {
        position: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 0 }
        }
    },
    text: {
        position: {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: -60 }
        }
    }
};